// extracted by mini-css-extract-plugin
export default {"input":"y8-z","button":"z8-z","selected":"A8-z","unavailable":"B8-z","oos":"C8-z","image":"D8-z","paperCutDisabledOverlay":"E8-z"};